import { takeEvery, call, put, takeLatest } from 'redux-saga/effects';

import { logout, signup, login, updateUser, getUser } from './api';
import {
  receiveAuth,
  receiveLogout,
  REQUEST_LOGIN,
  REQUEST_LOGOUT,
  REQUEST_SIGNUP,
  UPDATE_USER_PENDING,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  receiveUser,
  REQUEST_USER
} from './actions';

function* putUser({ payload: { data, redirect } }) {
  yield put({ type: UPDATE_USER_PENDING });

  try {
    const updatedUser = yield call(updateUser, data);
    yield put({ type: UPDATE_USER_SUCCESS, payload: updatedUser });
  } catch (error) {
    yield put({ type: UPDATE_USER_ERROR });
    console.error(error); // eslint-disable-line
  }
}

export function* updateUserSaga() {
  yield takeLatest(UPDATE_USER_PENDING, putUser);
}

function* callLogin({ payload: { data, redirect, strategy } }) {
  const auth = yield call(login, data, strategy);
  if (auth && auth.user) {
    yield put(receiveAuth(auth.user));
    redirect();
  }
}

export function* callReceiveAuth(user) {
  if (user && user.email) {
    yield put(receiveAuth(user));
  }
}

export function* loginSaga() {
  yield takeEvery(REQUEST_LOGIN, callLogin);
}

function* callSignup({ payload: { redirect, data } }) {
  const result = yield call(signup, data);
  if (result && typeof result === 'object') {
    redirect();
  }
}

export function* signupSaga() {
  yield takeEvery(REQUEST_SIGNUP, callSignup);
}

function* callLogout() {
  yield call(logout);
  yield put(receiveLogout({}));
}

export function* logoutSaga() {
  yield takeEvery(REQUEST_LOGOUT, callLogout);
}

function* callGetUser({ payload }) {
  const user = yield call(getUser, payload);
  yield put(receiveUser(user));
}

export function* getUserSaga() {
  yield takeEvery(REQUEST_USER, callGetUser);
}



// WEBPACK FOOTER //
// ./src/modules/user/sagas.js